import React from 'react';
import { SEO } from '../components/SEO';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { CommandCenter } from '../components/CommandCenter';
import { Testimonials } from '../components/Testimonials';
import { HowItWorks } from '../components/HowItWorks';
import { Impact } from '../components/Impact';
import { Solutions } from '../components/Solutions';
import { CallToAction } from '../components/CallToAction';

export const Home = () => {
  return (
    <>
      <SEO
        title="ProfitIQ.AI - Transform Your Business with AI-Driven Intelligence"
        description="Leverage advanced artificial intelligence to optimize your business operations, maximize profitability, and drive sustainable growth with ProfitIQ.AI's comprehensive business intelligence platform."
        type="website"
      />
      <Hero />
      <Features />
      <Impact />
      <CommandCenter />
      <HowItWorks />
      <Solutions />
      <Testimonials />
      <CallToAction />
    </>
  );
};